export default __webpack_public_path__ + "static/media/ourMission2.cce53f67.png";